import "./Results.css";

import React, {memo, useState} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronDown, faChevronUp} from '@fortawesome/free-solid-svg-icons';

import {PhraseTestResult} from "features/validationRules/types";

const PhraseTestResultComponent = ({phrase: {absent_in, common_for, phrase}}: { phrase: PhraseTestResult }) => {
    const [extended, setExtended] = useState<boolean>(false);

    return (
        <div className={"res-wrapper"}>
            <div className="res-container" onClick={() => {if (common_for.length > 0) setExtended(!extended)}}>
                <p className="res-name">"{phrase}"{extended? "" :" (common for "+common_for.length+"/"+(common_for.length+absent_in.length)+" docs)"}</p>
                <div className="chevron-wrapper" style={{display: common_for.length > 0? "flex" : "none"}}>
                    <FontAwesomeIcon icon={extended? faChevronUp : faChevronDown} />
                </div>
            </div>
            <div className="extendable-res-container" style={{display: extended? "flex" : "none"}}>
                {common_for.map(link => <a key={link} className="extendable-res-container-content" target="_blank" rel="noreferrer" href={link}>{link.split('&')[1].split('=')[1]}</a>)}
                {absent_in.length > 0? <p className="absent-in-message">Absent in:</p> : <></>}
                {absent_in.map(link => <a key={link} className="extendable-res-container-content missed-file" target="_blank" rel="noreferrer" href={link}>{link.split('&')[1].split('=')[1]}</a>)}
            </div>
        </div>
    );
}

export default memo(PhraseTestResultComponent);